module.exports = __webpack_public_path__ + "images/runner.svg";


//////////////////
// WEBPACK FOOTER
// ./get-quotes/images/runner.svg
// module id = 162
// module chunks = 1